
<mat-table #table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="30">Nom</mat-header-cell>
        <mat-cell *matCellDef="let link" fxFlex="30">
            <span *ngIf="link != editedLink; else linkEditionName">{{link.name}}</span>
            <ng-template #linkEditionName>
                <mat-form-field class="form-link__field" appearance="outline">
                    <mat-label>Nom</mat-label>
                    <input matInput [(ngModel)]="editedLinkValues.name" />
                    <mat-hint *ngIf="!editedLinkValues.name">Valeur requise</mat-hint>
                </mat-form-field>
            </ng-template>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="url">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="60">Url</mat-header-cell>
        <mat-cell *matCellDef="let link" fxFlex="60">
            <span *ngIf="link != editedLink; else linkEditionUrl">{{link.url}}</span>
            <ng-template #linkEditionUrl>
                <mat-form-field class="form-link__field" appearance="outline">
                    <mat-label>Url</mat-label>
                    <input matInput [(ngModel)]="editedLinkValues.url" />
                    <mat-hint *ngIf="!editedLinkValues.url">Valeur requise</mat-hint>
                </mat-form-field>
            </ng-template>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef fxFlex="10"></mat-header-cell>
        <mat-cell *matCellDef="let link" fxFlex="10">
            <ng-container *ngIf="link != editedLink; else linkEdition">
                <mat-icon class="form-link--clickable" (click)="editLink(link)" svgIcon="pencil-outline"></mat-icon>
                <mat-icon class="form-link--clickable" (click)="deleteLink(link)" svgIcon="delete-outline" [style.margin-left]="'0.5em'"></mat-icon>
            </ng-container>
            <ng-template #linkEdition>
                <mat-icon class="form-link--clickable" (click)="confirmLinkEdition()" svgIcon="check"></mat-icon>
                <mat-icon class="form-link--clickable" (click)="cancelLinkEdition()" svgIcon="close" [style.margin-left]="'0.5em'"></mat-icon>
            </ng-template>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns" [style.margin-bottom]="'0.5em'"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" [style.height]="'90px'"></mat-row>
</mat-table>

<div class="form-link-create">
    <span class="mat-header-cell">Ajouter un nouveau lien</span>
    <form [formGroup]="createLinkForm" (ngSubmit)="addLink()" style="margin-top: 0.5em;">
        <div class="form-fields-container" fxLayout="row" fxLayoutGap="1em" fxLayoutAlign="start start">
            <mat-form-field fxLayout="column" fxFlex="30" appearance="outline">
                <mat-label>Nom</mat-label>
                <input matInput placeholder="Nom" formControlName="name"/>
            </mat-form-field>

            <mat-form-field fxLayout="column" fxFlex="70" appearance="outline">
                <mat-label>Url</mat-label>
                <input matInput placeholder="Url" formControlName="url"/>
            </mat-form-field>
        </div>
        <div class="add-button-container" fxLayout="row" fxLayoutAlign="end end">
            <button mat-raised-button
                color="primary"
                type="submit"
                [disabled]="!createLinkForm.valid"
                name="action">
                Ajouter
            </button>
        </div>
    </form>
</div>